<div id="therapie" class="page-wrapper">

  <app-menu [activeMenuIndex]="3">
  </app-menu>

  <!--<div class="subheader-bar-wrapper">
    <div class="subheader-content">
      <a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
        <div class="subheader-content-text">
          Ihr kostenfreies Testset!
        </div>
      </a>
    </div>
  </div>-->

  <div class="floating-chameleon">
  </div>

  <!-- <div class="content-icon">
    <img src="/assets/img/template/icon-home-btn.svg" />
  </div> -->

  <span class="icon-care ico page-intro green"></span>

  <div class="title-wrapper">

    <h1>
      Therapie
    </h1>

  </div>

  <div class="info-section info-section-1">

    <div class="info-section-subtitle">
      <h2>
        Therapieoptionen
      </h2>
    </div>

      <div class="info-section-text info-section-text-1">
        Heute stehen zwei unterschiedliche Therapieansätze zur Verfügung.<sup class="info-section-text-ref">1</sup> Beide zielen darauf ab, Organschäden zu verhindern bzw. in fortgeschrittenem Stadium eine Stabilisierung der Organfunktion zu erreichen. Zudem hat die Enzymersatztherapie offenbar einen positiven Effekt auf das Langzeitüberleben. Die Enzymersatztherapie muss regelmäßig und lebenslang durchgeführt werden.<br>
        Dem Patienten wird dabei alle zwei Wochen per Infusion das fehlende Enzym zugeführt.<br>
        <br>
        Neben der Enzymersatztherapie gibt es seit einiger Zeit auch eine Behandlungsoption mit<br>
        pharmakologischen Chaperonen, die jedoch nur für eine Untergruppe von Fabry-Patienten infrage kommt (abhängig von der spezifischen Mutation). Auch hierbei handelt es sich um eine lebenslange Therapie.<br>
      </div>

    <!--<div class="info-section-text info-section-text-1">
        Bereits seit 2001 existiert die kausale Therapie durch Enzymersatz mit Agalsidase
        alfa bzw. Agalsidase beta, seit 2016 gibt es die mutationsspezifische Enzym-Enhancement-Therapie mit Migalastat.
    </div>

    <div class="info-section-subtitle">
      <h2>
        Enzymersatztherapie (EET)
      </h2>
    </div>

    <div class="info-section-list">
      <ul>
        <li>
          Agalsidase alfa <a href="https://www.takeda-produkte.de/products/replagalr-1-mgml-konzentrat-zur-herstellung-einer-infusionsloesung" target="_blank">(Replagal)</a> wird in einer humanen Zelllinie hergestellt und in einer Dosis<br>
          von 0,2 mg/kg Körpergewicht alle zwei Wochen intravenös verabreicht<sup class="info-section-text-ref">2</sup>
        </li>
        <li class="last-item ">
          Agalsidase beta wird rekombinant in <span matTooltip='Chinese Hamster Ovary' matTooltipPosition="below">CHO</span>-Zellen produziert und mit einer<br>
          Dosis von 1,0 mg/kg Körpergewicht alle zwei Wochen intravenös verabreicht<sup class="info-section-text-ref">3</sup>
        </li>
      </ul>
    </div>

    <div class="info-section-subtitle">
      <h2>
        Enzym-Enhancement-Therapie
      </h2>
    </div>

    <div class="info-section-list">
      <ul>
        <li>
          Migalastat ist ein pharmakologisches Chaperon, das in einer Dosis von
          <span class="no-lb">123 mg</span> alle zwei Tage als Kapsel per os eingenommen wird<sup class="info-section-text-ref">1</sup>
        </li>
        <li class="last-item ">
          Migalastat ist nur bei Vorliegen von Mutationen wirksam, bei denen eine Restaktivität der <span class="no-lb">α-Galaktosidase</span> vorhanden ist und eine Ansprechbarkeit im Zellkulturmodell nachgewiesen wurde
        </li>
      </ul>
    </div>-->

  </div>

  <div class="info-section-ribbon info-section-2">

    <div class="info-section-ribbon-left">
    </div>

    <div class="info-section-ribbon-right">
    </div>

    <div class="info-section-title">
      <h2>
        Leitlinien-Empfehlung für weibliche und männliche Patienten:
      </h2>
    </div>

    <div class="info-section-text">
      Die Indikation zur <span matTooltip='Enzymersatztherapie' matTooltipPosition="below" matTooltipClass="tooltipContrast">EET</span>
      ist unabhängig vom Alter* immer bei Zeichen einer
      relevanten Organmanifestation (Herz, Niere, Gehirn, Schmerzen) gegeben.
      Die Behandlung ist lebenslang erforderlich.<sup class="info-section-text-ref">1</sup>
    </div>

    <div class="info-section-text-legend">
      * Bitte Hinweise in den Fachinformationen beachten.
    </div>

  </div>

  <div class="info-section info-section-3">

    <!-- <div class="info-section-subtitle">
      <h2>
        Die Wirkweise von Replagal<sup class="info-section-text-ref">®</sup>
      </h2>
    </div>

    <div class="info-section-text info-section-text-1">
      Informationen zur Wirkweise der Enzymersatztherapie mit Replagal<sup class="info-section-text-ref">®</sup> (Agalsidase alfa) erhalten
          Sie im folgenden Video.
    </div>

    <div class="info-section-graphic-1">
      <img src="/assets/img/template/icon_14_temp.png" />
    </div>

    <a href="/assets/downloads/Fachinformationen_Replagal.pdf" class="info-section-button-1">
      Fachinformation Replagal<sup class="info-section-text-ref">®</sup>
    </a> -->

    <div class="info-section-subtitle info-section-subtitle-1">
      <h2>
        Krankheitsspezifisches Patientenmanagement
      </h2>
    </div>

    <div class="info-section-graphic-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="880" height="952" viewBox="0 0 880 952">
          <g fill="none" fill-rule="evenodd">
              <path stroke="#009994" stroke-width="4" d="M82 2H798V78H82zM82 300H798V376H82z"/>
              <path fill="#009994" stroke="#009994" stroke-width="4" d="M82 725H798V801H82z"/>
              <path stroke="#009994" stroke-width="4" d="M82 576H798V681H82z"/>
              <path fill="#38AA34" d="M80 843H420V952H80z"/>
              <path fill="#F39100" d="M460 843H800V952H460z"/>
              <path stroke="#009994" stroke-width="4" d="M82 122H798V256H82zM82 420H798V532H82z"/>
              <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="236" y="50">Bestätigte Diagnose von Morbus Fabry</tspan>
              </text>
              <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="249" y="348">Definition der therapeutischen Ziele</tspan>
              </text>
              <text fill="#FFF" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="320" y="773">Therapieziele erreicht?</tspan>
              </text>
              <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="217" y="624">Regelmäßiges Monitoring zur Beurteilung </tspan> <tspan x="326.372" y="652.6">des klinischen Status</tspan>
              </text>
              <text fill="#FFF" font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500">
                  <tspan x="241.36" y="877">JA</tspan> <tspan x="198" y="902.6">Behandlung</tspan> <tspan x="198" y="928.2">beibehalten</tspan>
              </text>
              <text fill="#FFF" font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500">
                  <tspan x="608.133" y="877">NEIN</tspan> <tspan x="489.656" y="902.6">Optimieren der therapeutischen </tspan> <tspan x="518.392" y="928.2">Ziele und der Behandlung</tspan>
              </text>
              <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="238.643" y="170">Umfassende Anfangsuntersuchung: </tspan> <tspan x="110" y="198.6">Beurteilung der Organsysteme auf Morbus-Fabry-Anzeichen </tspan> <tspan x="343.669" y="227.2">und -Symptome</tspan>
              </text>
              <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="22" font-weight="500">
                  <tspan x="218.109" y="467.526">Geeigneten Therapieplan festlegen und </tspan> <tspan x="192.307" y="496.126">dem Patienten die Therapieschritte erklären</tspan>
              </text>
              <path fill="#000" fill-rule="nonzero" d="M430.865 117.85l8.984-8.96c.201-.2.201-.525 0-.726l-.85-.847c-.201-.202-.527-.202-.73 0l-6.653 6.635V83.513c0-.282-.232-.513-.515-.513h-1.202c-.283 0-.515.231-.515.513v30.439l-6.654-6.635c-.202-.202-.528-.202-.73 0l-.849.847c-.201.2-.201.526 0 .727l8.984 8.958c.202.201.528.201.73 0zM430.865 295.85l8.984-8.96c.201-.2.201-.525 0-.726l-.85-.847c-.201-.202-.527-.202-.73 0l-6.653 6.635v-30.439c0-.282-.232-.513-.515-.513h-1.202c-.283 0-.515.231-.515.513v30.439l-6.654-6.635c-.202-.202-.528-.202-.73 0l-.849.847c-.201.2-.201.526 0 .727l8.984 8.958c.202.201.528.201.73 0zM430.865 415.85l8.984-8.96c.201-.2.201-.525 0-.726l-.85-.847c-.201-.202-.527-.202-.73 0l-6.653 6.635v-30.439c0-.282-.232-.513-.515-.513h-1.202c-.283 0-.515.231-.515.513v30.439l-6.654-6.635c-.202-.202-.528-.202-.73 0l-.849.847c-.201.2-.201.526 0 .727l8.984 8.958c.202.201.528.201.73 0zM430.865 571.85l8.984-8.96c.201-.2.201-.525 0-.726l-.85-.847c-.201-.202-.527-.202-.73 0l-6.653 6.635v-30.439c0-.282-.232-.513-.515-.513h-1.202c-.283 0-.515.231-.515.513v30.439l-6.654-6.635c-.202-.202-.528-.202-.73 0l-.849.847c-.201.2-.201.526 0 .727l8.984 8.958c.202.201.528.201.73 0zM430.865 720.85l8.984-8.96c.201-.2.201-.525 0-.726l-.85-.847c-.201-.202-.527-.202-.73 0l-6.653 6.635v-30.439c0-.282-.232-.513-.515-.513h-1.202c-.283 0-.515.231-.515.513v30.439l-6.654-6.635c-.202-.202-.528-.202-.73 0l-.849.847c-.201.2-.201.526 0 .727l8.984 8.958c.202.201.528.201.73 0zM59.82 619.091l.07.06 8.96 8.984c.178.18.198.457.059.658l-.06.072-8.958 8.984c-.179.179-.456.199-.656.06l-.071-.06-.847-.85c-.18-.179-.199-.457-.06-.658l.06-.071 6.635-6.654-62.953-.001L2 896.999 80 897v2H2c-1.105 0-2-.895-2-2V628.38c0-.552.448-1 1-1h1l-.001.004h62.953l-6.635-6.654c-.18-.18-.199-.457-.06-.658l.06-.071.847-.85c.178-.179.455-.199.656-.06zM878 899c1.105 0 2-.895 2-2V339c0-.552-.448-1-1-1h-1v.003h-62.952l6.635-6.654c.18-.179.199-.456.06-.657l-.06-.072-.847-.85c-.178-.179-.455-.199-.656-.06l-.07.06-8.96 8.985c-.178.179-.198.456-.059.658l.06.071 8.958 8.984c.179.18.456.2.656.06l.071-.06.847-.85c.18-.179.199-.456.06-.657l-.06-.072-6.635-6.654H878l.001 556.764L800 897v2h78z"/>
          </g>
      </svg>

    </div>

    <div class="info-section-subtitle info-section-subtitle-1">
      <h2>
        Fokus der Therapie für die verschiedenen Organsysteme im Überblick (Auswahl)
      </h2>
    </div>

    <div class="info-section-graphic-33">

      <div class="cell small-12 large-6 text-center">
        <div class="specialist-box">

          <img class="specialist-hexa" src="/assets/img/template/specialist-hexa.svg" alt="">

          <span id="DescDoctor" class="badge specialist-link achnorpulse specialist-doctor">
            <span class="icon-brain  ico"></span>
          </span>
          <span id="DescHeart" class="badge specialist-link achnorpulse specialist-heart">
            <span class="icon-heart ico"></span>
          </span>
          <span id="DescKidney" class="badge specialist-link achnorpulse specialist-kidney">
            <span class="icon-kidney ico"></span>
          </span>
          <span id="DescEye" class="badge specialist-link achnorpulse specialist-eye">
            <!-- <span class="icon-sonic ico"></span> -->
            <span class="ico-head-pain-d ico-custom-sm"></span>
          </span>
          <span id="DescBaby" class="badge specialist-link achnorpulse specialist-baby">
            <span class="icon-bowel ico"></span>
          </span>
          <span id="DescBrain" class="badge specialist-link achnorpulse specialist-brain">
            <span class="icon-ear ico"></span>
          </span>
          <span id="DescDna" class="badge specialist-link achnorpulse specialist-dna">
            <span class="icon-nerves ico"></span>
          </span>
        </div>
      </div>

      <!-- <div class="info-center-graphic">
        <img src="/assets/img/template/icon_16_temp.png" />
      </div>

      <div class="info-floating-graphic-1">
        <img src="/assets/img/template/icon_15_temp.png" />
      </div>

      <div class="info-floating-graphic-2">
        <img src="/assets/img/template/icon_15_temp.png" />
      </div>

      <div class="info-floating-graphic-3">
        <img src="/assets/img/template/icon_15_temp.png" />
      </div>

      <div class="info-floating-graphic-4">
        <img src="/assets/img/template/icon_15_temp.png" />
      </div> -->


    </div>

    <a id="section-3"></a>
    <div class="info-section-specialist-description">

      <div class="cell small-12 large-8 text-center bg-cyan">
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescDoctor" style="display: none">
          <span class="specialist-icon badge"><span class="icon-brain ico"></span></span>
          <div class="h3 specialist-desc-title">ZNS</div>
          <p class="specialist-desc-text">
            <!-- Neben dem Fabry-Zentrum/Facharzt ist es wichtig, zum Beispiel Ihren Hausarzt über die Diagnose Morbus Fabry und gegebenenfalls über eine Therapie zu informieren. -->
            <span matTooltip='Transitorische ischämische Attacken' matTooltipPosition="below" matTooltipClass="tooltipContrast">TIA</span>/Schlaganfälle verhindern;
            <br>
            Zunahme
            <span matTooltip='White matter lesions' matTooltipPosition="below" matTooltipClass="tooltipContrast">WML</span>
            verhindern
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescHeart" style="display: none">
          <span class="specialist-icon badge"><span class="icon-heart ico"></span></span>
          <div class="h3 specialist-desc-title">Herz</div>
          <p class="specialist-desc-text">
            <!-- Von Morbus Fabry ist häufig das <span data-href="/allgemein/symptome/#DescHeart" class="text-link smoothscroller">Herz</span> betroffen. Mithilfe von Ultraschalluntersuchungen und einem Elektrokardiogramm (EKG) kann der Kardiologe den Zustand des Herzens überprüfen. -->
            Morbidität und vorzeitige Mortalität vermeiden oder verringern; linksventrikuläre Hypertrophie vermeiden oder Progression vermindern; arrhythmiebedingten plötzlichen Herztod (tachykard/bradykard) und kardiogen-embolische Schlaganfälle verhindern;
            <br>
            funktionelle Verschlechterung bei Herzinsuffizienz verhindern
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescKidney" style="display: none">
          <span class="specialist-icon badge"><span class="icon-kidney ico"></span></span>
          <div class="h3 specialist-desc-title">Niere</div>
          <p class="specialist-desc-text">
            <!-- Morbus Fabry kann die <span data-href="/allgemein/symptome/#DescKidney" class="text-link smoothscroller">Nieren</span> schädigen und sogar zum Nierenversagen führen. Deshalb ist es wichtig ihre Funktionsfähigkeit regelmäßig zu überprüfen. -->
            Ausmaß der Albuminurie so gering wie möglich halten;
            <br>
            <span matTooltip='geschätzte glomeruläre Filtrationsrate' matTooltipPosition="below" matTooltipClass="tooltipContrast">eGFR</span>
            im normalen Rahmen halten;
            <br>
            Progression verhindern;
            <br>
            terminale Niereninsuffizienz verhindern oder hinauszögern
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescEye" style="display: none;">
          <span class="specialist-icon badge"><span class="ico-head-pain ico-custom-md"></span></span>
          <div class="h3 specialist-desc-title">Hypohidrose</div>
          <p class="specialist-desc-text">
            <!-- Er kann eine <span data-href="/allgemein/symptome/#DescEye" class="text-link smoothscroller">Hornhauttrübung</span> mit Hilfe einer Spaltlampenuntersuchung feststellen. -->
            Schweißbildung erhöhen,
            <br>
            Fieber-Episoden vermeiden
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescBaby" style="display: none">
          <span class="specialist-icon badge"><span class="icon-bowel ico"></span></span>
          <div class="h3 specialist-desc-title">Gastrointestinales System</div>
          <p class="specialist-desc-text">
            <!-- Bei jugendlichen Patienten und Kindern ersetzt der Kinderarzt den Hausarzt. Er ist spezialisiert auf die Bedürfnisse und Besonderheiten von Heranwachsenden. -->
            Progression von GI-Symptomen vermeiden, reduzieren, mindern
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescBrain" style="display: none">
          <span class="specialist-icon badge white"><span class="icon-ear ico"></span></span>
          <div class="h3 specialist-desc-title">Audio-vestibuläres System</div>
          <p class="specialist-desc-text">
            <!-- Viele Symptome des Morbus Fabry, zum Beispiel das Kribbeln und Brennen in Händen und Füßen, der Schlaganfall und andere neurologische Auffälligkeiten, werden durch Schädigungen der Nerven oder des Gehirns verursacht. Ein Neurologe oder Schmerzmediziner dokumentiert den Verlauf der Schmerzen und die Lebensqualität. Er ist der Ansprechpartner für die Schmerztherapie. -->
            Hörvermögen stabilisieren;
            <br>
            Hilfsmittel verordnen
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
        <!-- Desc -->
        <div class="specialist-desc" data-desc-box="DescDna" style="display: none">
          <span class="specialist-icon badge"><span class="icon-nerves ico"></span></span>
          <div class="h3 specialist-desc-title">Peripheres Nervensystem</div>
          <p class="specialist-desc-text">
            <!-- Die genetische Untersuchung gibt Auskunft darüber, welche Mutation vorliegt. In der <a href="https://www.gfhev.de/de/beratungsstellen/beratungsstellen.php" target="_blank">humangenetischen Beratung</a> werden alle Fragen zur Vererbung der Erkrankung besprochen und analysiert, zum Beispiel, ob möglicherweise weitere Angehörige oder Kinder betroffen sind. -->
            Intensität und Frequenz neuropathischer Schmerzen verringern;
            <br>
            Schmerzkrisen verhindern
          </p>
          <span class="close-specialist-desc"><span class="icon-up ico"></span></span>
        </div>
      </div>

    </div>

    <!-- <div class="info-section-block-solid">

      <div>
        <img src="/assets/img/template/icon_17_temp.png" />
      </div>
      <div class="info-section-block-title">
        Niere
      </div>
      <div class="info-section-block-text">
        Ausmaß der Albuminurie so gering wie möglich halten; eGFR im normalen
        Rahmen halten; Progression verhindern; end-stage renal failure verhindern
        oder hinauszögern.
      </div>
      <div>
        <img src="/assets/img/template/icon_18_temp.png" />
      </div>


    </div> -->

    <div class="info-section-subtitle info-section-subtitle-3">
      <h2>
        Multidisziplinäre Betreuung
      </h2>
    </div>

    <div class="info-section-text info-section-text-2">
      Morbus Fabry als Multiorganerkrankung braucht ein spezialisiertes multidisziplinäres Team zur
      Betreuung der Patienten.<sup class="info-section-text-ref">2</sup>
    </div>

    <div class="info-section-columns">

      <div class="info-section-column">
        <div class="info-section-column-title">
          <h3>
            Klinische Fächer
          </h3>
        </div>
        <div class="info-section-column-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-book ico"></span></span>
        </div>

        <div class="info-section-block-list">

          <ul>
            <li>
              Leitender Arzt (w/m)
            </li>
            <li>
              Pflegespezialisten
            </li>
            <li>
              Pädiatrie
            </li>
            <li>
              Neurologie
            </li>
            <li>
              Kardiologie
            </li>
            <li>
              Dermatologie
            </li>
            <li>
              Nephrologie/Dialyse
            </li>
            <li>
              Gastroenterologie
            </li>
            <li>
              Ophthalmologie
            </li>
            <li>
              HNO
            </li>
            <li>
              Humangenetik
            </li>
            <li>
              Palliativmedizin
            </li>
            <li class="last-item">
              Physikalische Therapie/Ergotherapie
            </li>
          </ul>
        </div>

        <!-- <div class="info-section-column-text">
          Leitender Arzt (w/m)
        </div>
        <div class="info-section-column-text">
          Pflegespezialisten
        </div>
        <div class="info-section-column-text">
          Pädiatrie
        </div>
        <div class="info-section-column-text">
          Neurologie
        </div>
        <div class="info-section-column-text">
          Kardiologie
        </div>
        <div class="info-section-column-text">
          Dermatologie
        </div>
        <div class="info-section-column-text">
          Nephrologie/Dialyse
        </div>
        <div class="info-section-column-text">
          Gastroenterologie
        </div>
        <div class="info-section-column-text">
          Ophthalmologie
        </div>
        <div class="info-section-column-text">
          HNO
        </div>
        <div class="info-section-column-text">
          Humangenetik
        </div>
        <div class="info-section-column-text">
          Palliativmedizin
        </div>
        <div class="info-section-column-text">
          Physikalische/Ergo-Therapie
        </div> -->
      </div>

      <div class="info-section-column">
        <div class="info-section-column-title">
          <h3>
            Diagnostik
          </h3>
        </div>
        <div class="info-section-column-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-care ico"></span></span>
        </div>

        <div class="info-section-block-list">

          <ul>
            <li>
              Klinisch-chemisches Labor
            </li>
            <li>
              Genetisches Labor
            </li>
            <li>
              Radiologie
            </li>
            <li>
              Nuklearmedizin
            </li>
            <li class="last-item">
              Pathologie
            </li>
          </ul>

        </div>

        <!-- <div class="info-section-column-text">
          Klinisch-chemisches Labor
        </div>
        <div class="info-section-column-text">
          Genetisches Labor
        </div>
        <div class="info-section-column-text">
          Radiologie
        </div>
        <div class="info-section-column-text">
          Nuklearmedizin
        </div> -->
      </div>

      <div class="info-section-column">
        <div class="info-section-column-title">
          <h3>
            Unterstützung
          </h3>
        </div>
        <div class="info-section-column-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-hands ico"></span></span>
        </div>
        <div class="info-section-block-list">

          <ul>
            <li>
              Apotheke
            </li>
            <li>
              Verwaltung
            </li>
            <li>
              Sozialarbeiter
            </li>
            <li>
              Selbsthilfevereinigung
            </li>
          </ul>

        </div>
        <!-- <div class="info-section-column-text">
          Apotheke
        </div>
        <div class="info-section-column-text">
          Verwaltung
        </div>
        <div class="info-section-column-text">
          Sozialarbeiter
        </div>
        <div class="info-section-column-text">
          Selbsthilfevereinigung
        </div> -->
      </div>

    </div>

    <div class="info-section-subtitle info-section-subtitle-2">
      <h2>
        Humangenetische Beratung
      </h2>
    </div>

    <div class="info-section-text info-section-text-3">
      Die genetische Beratung des Patienten gehört zum multidisziplinären Behandlungsansatz von<br>
      Fabry-Patienten.<sup class="info-section-text-ref">3,4</sup>
    </div>

    <div class="info-section-link">
      <!-- <div class="info-section-link-icon"> -->
        <!-- <img src="/assets/img/template/icon_8_temp.png" /> -->
        <!-- <span class="graphic-icon"><span class="icon-arrow-right ico"></span></span> -->
      <!-- </div> -->
      <span class="link-arrow-right icon-arrow-right ico cyan"></span>
      <a href="https://www.gfhev.de/de/beratungsstellen/beratungsstellen.php" target="_blank" class="section-link">
        Adressverzeichnis genetischer Beratungseinrichtungen
      </a>
    </div>

    <div class="info-section-7">
        <div class="info-section-container">

          <div class="info-section-block info-section-block-1">
            <div class="info-section-icon">
              <!-- <img src="/assets/img/template/icon_19_temp.png" /> -->
              <span class="graphic-icon"><span class="icon-dna ico"></span></span>
            </div>
          </div>

          <div class="info-section-block info-section-block-2">

            <div class="info-section-block-title">
              Themen der genetischen Beratung:<!--<sup class="info-section-text-ref">1</sup>-->
            </div>

            <div class="info-section-block-list info-section-block-list-down">

              <ul>
                <li>
                  Aufklärung über medizinische, psychologische und familiäre Auswirkungen der Diagnose
                </li>
                <li>
                  Vererbungsmodus
                </li>
                <li>
                  Untersuchungen von Verwandten
                </li>
                <li>
                  Variable Symptomatik
                </li>
                <li>
                  Verschiedene Untersuchungsmethoden
                </li>
                <li>
                  Zur Verfügung stehende Therapieoptionen
                </li>
                <li>
                  Beratung zu psychosozialen Problemen
                </li>
                <li class="last-item">
                  Informationen zum Thema Kinderwunsch
                </li>
              </ul>

            </div>

          </div>

        </div>
    </div>

  </div>

  <!-- <div class="info-section-ribbon info-section-4">

    <div class="info-section-ribbon-left">
    </div>

    <div class="info-section-ribbon-right">
    </div>

    <div class="info-section-title">
      Die Stammbaumanalyse hilft, weitere Angehörige zu identifizieren!
    </div>

    <div class="info-section-text">
      Auf jeden Indexpatienten kommen in der erweiterten Familie schätzungsweise drei bis fünf
      weitere Fälle.<sup class="info-section-text-ref">9</sup> Deshalb sollte eine Familien- und Stammbaumanalyse bei neu diagnostizierten
      Fabry-Patienten unbedingt erfolgen, um Angehörige mit erhöhtem Krankheitsrisiko schneller zu identifizieren.<sup class="info-section-text-ref">7,10</sup>
    </div>

  </div> -->

  <div class="info-section info-section-5">

    <div class="info-section-subtitle">
      <h2>
        Follow-up-Untersuchungen
      </h2>
    </div>

    <div class="info-section-text info-section-text-1">
      Nach Diagnose eines Morbus Fabry sollte eine Eingangsuntersuchung der typischerweise
      betroffenen Organe und Organsysteme durchgeführt werden:<sup class="info-section-text-ref">1</sup>
    </div>

    <div class="info-section-graphics">

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-heart ico"></span></span>
        </div>
        <div class="info-section-icon-text">
          Herz
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-kidney ico"></span></span>
        </div>
        <div class="info-section-icon-text">
          Nieren
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-brain ico"></span></span>
        </div>
        <div class="info-section-icon-text">
          Gehirn
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-nerves ico cyan"></span></span>
        </div>
        <div class="info-section-icon-text">
          Peripheres Nervensystem
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-skin ico cyan"></span></span>
        </div>
        <div class="info-section-icon-text">
          Haut
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-bowel ico cyan"></span></span>
        </div>
        <div class="info-section-icon-text">
          Gastrointestinaltrakt
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-eye ico cyan"></span></span>
        </div>
        <div class="info-section-icon-text">
          Augen
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <span class="graphic-icon badge turquoise"><span class="icon-ear ico cyan"></span></span>
        </div>
        <div class="info-section-icon-text">
          Ohren
        </div>
      </div>

      <div class="info-section-graphic">
        <div class="info-section-icon">
          <!-- <img src="/assets/img/template/icon_15_temp.png" /> -->
          <!-- <span class="graphic-icon badge turquoise"><span class="icon-bowel ico cyan"></span></span> -->
          <span class="graphic-icon badge turquoise"><span class="ico-pain-cyan ico-custom"></span></span>
        </div>
        <div class="info-section-icon-text" style="text-align: center;">
          Schmerzanamnese und Fragebogen zur Lebensqualität
        </div>
      </div>

    </div>

    <div class="info-section-separator">
    </div>

    <div class="info-section-text info-section-text-2">
      Die Eingangsuntersuchungen und Follow-up-Analysen sind bei Frauen und Männern gleich. Sie
      richten sich nach Art und Ausmaß der Organbeteiligung.<sup class="info-section-text-ref">1</sup>
    </div>

  </div>

  <div class="info-section-ribbon info-section-6" style="margin-bottom: 100px;">

    <div class="info-section-ribbon-left">
    </div>

    <div class="info-section-ribbon-right">
    </div>

    <div class="info-section-text">
<!--      Morbus Fabry-Patienten sollten von <a href="/infocenter#map">spezialisierten Zentren</a> betreut werden und sich dort
      mindestens einmal im Jahr zu Kontrolluntersuchungen vorstellen.-->
      Morbus Fabry-Patienten sollten von <a routerLink="/infocenter" fragment="mapImage">spezialisierten Zentren</a> betreut werden und sich dort
      mindestens einmal im Jahr zu Kontrolluntersuchungen vorstellen.
    </div>

  </div>

  <div class="info-section info-section-7">

    <div class="info-section-subtitle">
      <h2>
        Betreuung von Patienten mit unklaren Varianten
      </h2>
    </div>

    <div class="info-section-list">
      <ul>
        <li>
          Fabry-Screenings in Hochrisikogruppen (chronische Nierenerkrankung, juveniler
          Schlaganfall/<span matTooltip='Transitorische ischämische Attacken' matTooltipPosition="below">TIA</span>,
          linksventrikuläre Hypertrophie) haben eine Vielzahl an
          <span matTooltip='genetic variants of unknown significance' matTooltipPosition="below">GVUS</span>
          gezeigt bzw. Varianten, die
          kontrovers hinsichtlich ihrer Klassifikation diskutiert werden (z. B. <span class="title-description-i">p.D313Y</span>,
          <span class="title-description-i">p.A143T</span>,
          <span class="title-description-i">p.S126G</span>)<sup class="info-section-text-ref">5–7</sup>
        </li>
        <li>
          Zur Einordnung der klinisch-pathogenetischen Bedeutung solcher
          <span matTooltip='genetic variants of unknown significance' matTooltipPosition="below">GVUS</span>
          bzw. kontrovers
          diskutierten Varianten ist eine detaillierte Abklärung jedes einzelnen Patienten hinsichtlich
          möglicher Organmanifestationen notwendig (biochemische Analysen, funktionelle und
          bildgebende Organabklärung)<sup class="info-section-text-ref">5</sup>
        </li>
        <li class="last-item">
          Eine regelmäßige Untersuchung (mind. jährlich) sollte an einem Fabry-Zentrum erfolgen,
          auch um ggf. im Einzelfall über spezifische therapeutische Optionen zu entscheiden<sup class="info-section-text-ref">8</sup>
        </li>
      </ul>
    </div>

    <!--<div class="info-section-subtitle">
      <h2>
        Die Bedeutung frühzeitiger Therapie
      </h2>
    </div>

    <div class="info-section-text info-section-text-1">
      Ohne angemessene Therapie kann es bei Betroffenen zu einer deutlich
      <a routerLink="/diagnose"><span class="title-description-sb">reduzierten Lebenserwartung</span></a> kommen.<sup class="info-section-text-ref">15,16</sup>
    </div>

    <div class="info-section-text info-section-text-2">
      Geschätzte mediane Überlebenszeit<sup class="info-section-text-ref">*</sup>
    </div>

    <div class="info-section-container">

      <div class="info-section-block">
        <div class="info-section-graphic zoom-in-container" (click)="openDialog('therapie-chart-1')">-->

          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="450" height="252" viewBox="0 0 450 252">
              <g fill="none" fill-rule="evenodd">
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="194">40</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold">
                      <tspan x="189.313" y="15">(nur Männer n=279)</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="173">50</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="152">50</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="130">70</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="109">80</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="40.99" y="87">90</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="32.985" y="64">100</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="65.498" y="213">0</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="151.995" y="213">20</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="240.495" y="213">40</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="330.495" y="213">60</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="420.495" y="213">80</tspan>
                  </text>
                  <path stroke="#929897" stroke-linecap="square" stroke-width="2" d="M71 58.771V192.5M67 124h4m-4-23h4m-4 45h4m-4 22h4m-4-87h4m-4-22h4M448.75 189.5L66.5 189.5M159 189.5L159 193.5M249 189.5L249 193.5M338 189.5L338 193.5M428 189.5L428 193.5"/>
                  <path stroke="#007BB6" stroke-width="2" d="M71.5 59L225.819 59 225.819 60.85 251.002 60.85 251.002 62.748 260.053 62.748 260.053 64.094 262.439 64.094 262.439 66.308 274.175 66.308 274.175 68.553 276.577 68.553 276.577 71.407 281.119 71.407 281.119 74.332 296.747 74.332 296.747 85.566 298.099 85.566 298.099 93.61 301.134 93.61 301.134 102.601 323.887 102.601 323.887 109.991 329.281 109.991 329.281 119.038 331.464 119.038 331.464 128.616 334.813 128.616 334.813 140.07 337.285 140.07 337.285 189"/>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="rotate(-90 9.5 125.5)">
                      <tspan x="-77.792" y="131">Geschätztes Überleben (%)</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="10" font-weight="500">
                      <tspan x="126" y="174">Männer </tspan>
                  </text>
                  <path stroke="#007BB6" stroke-width="2" d="M95 171.5L122 171.5"/>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="207.198" y="248">Alter (in Jahren)</tspan>
                  </text>
              </g>
          </svg> -->
          <!-- <img src="/assets/img/template/group-14.png" > -->
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="448" height="245" viewBox="0 0 448 245">
              <g fill="none" fill-rule="evenodd">
                  <g>
                      <g>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="186">40</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="177.5" y="17">(nur Männer n = 279)</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="165">50</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="144">50</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="122">70</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="101">80</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="38.99" y="79">90</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="30.985" y="56">100</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="63.498" y="205">0</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="149.995" y="205">20</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="238.495" y="205">40</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="328.495" y="205">60</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="418.495" y="205">80</tspan>
                          </text>
                          <path stroke="#929897" stroke-linecap="square" stroke-width="2" d="M69 50.771V184.5M65 116h4m-4-23h4m-4 45h4m-4 22h4m-4-87h4m-4-22h4M446.75 181.5L64.5 181.5M157 181.5L157 185.5M247 181.5L247 185.5M336 181.5L336 185.5M426 181.5L426 185.5" transform="translate(-261 -9904) translate(261 9904)"/>
                          <path stroke="#007BB6" stroke-width="2" d="M69.5 51L223.819 51 223.819 52.85 249.002 52.85 249.002 54.748 258.053 54.748 258.053 56.094 260.439 56.094 260.439 58.308 272.175 58.308 272.175 60.553 274.577 60.553 274.577 63.407 279.119 63.407 279.119 66.332 294.747 66.332 294.747 77.566 296.099 77.566 296.099 85.61 299.134 85.61 299.134 94.601 321.887 94.601 321.887 101.991 327.281 101.991 327.281 111.038 329.464 111.038 329.464 120.616 332.813 120.616 332.813 132.07 335.285 132.07 335.285 181" transform="translate(-261 -9904) translate(261 9904)"/>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="16" transform="translate(-261 -9904) translate(261 9904) rotate(-90 11 129)">
                              <tspan x="-88.762" y="135">Geschätztes Überleben (%)</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="12" font-weight="500" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="130" y="166">Männer </tspan>
                          </text>
                          <path stroke="#007BB6" stroke-width="2" d="M93 161.5L120 161.5" transform="translate(-261 -9904) translate(261 9904)"/>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="16" transform="translate(-261 -9904) translate(261 9904)">
                              <tspan x="198.012" y="240">Alter (in Jahren)</tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </svg>


        </div>
        <div class="info-section-legend-bold">
          Unbehandelte Patienten<sup class="info-section-text-ref">17</sup>
        </div>
        <div class="info-section-legend">
          Abb. Modifiziert nach SCHIFFMANN, R. et al. 2019<sup class="info-section-text-ref">17</sup>
        </div>
        <div class="info-section-legend-sm">
          Historische Kohorte
        </div>


      </div>

      <div class="info-section-block">
        <div class="info-section-graphic zoom-in-container" (click)="openDialog('therapie-chart-2')">-->

          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="447" height="252" viewBox="0 0 447 252">
              <g fill="none" fill-rule="evenodd">
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="194">40</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="173">50</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="152">50</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="130">70</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="109">80</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="37.99" y="87">90</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="29.985" y="64">100</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="62.498" y="213">0</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="148.995" y="213">20</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="239.495" y="213">40</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="330.495" y="213">60</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="421.495" y="214">80</tspan>
                  </text>
                  <path stroke="#929897" stroke-linecap="square" stroke-width="2" d="M68 58.771V192.5M64 124h4m-4-23h4m-4 45h4m-4 22h4m-4-87h4m-4-22h4M445.75 189.5L63.5 189.5M157 189.5L157 193.5M249 189.5L249 193.5M338 189.5L338 193.5M429 189.5L429 193.5"/>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="rotate(-90 9.5 129.5)">
                      <tspan x="-77.792" y="135">Geschätztes Überleben (%)</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="10" font-weight="500">
                      <tspan x="123" y="174">Männer </tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="10" font-weight="500">
                      <tspan x="123" y="155">Frauen </tspan>
                  </text>
                  <path stroke="#007BB6" stroke-width="2" d="M92 171.5L119 171.5"/>
                  <path stroke="#D8137D" stroke-width="2" d="M92 152.5L119 152.5"/>
                  <text fill="#000" font-family="OpenSans, Open Sans" font-size="14">
                      <tspan x="204.198" y="248">Alter (in Jahren)</tspan>
                  </text>
                  <text fill="#000" font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold">
                      <tspan x="149.315" y="15">(Männer n=360; Frauen n=317)</tspan>
                  </text>
                  <path stroke="#007BB6" stroke-width="2" d="M68.5 59L185.53 59 185.53 60.947 252.632 60.947 252.632 62.853 281.403 62.853 281.403 64.205 283.407 64.205 283.407 65.739 287.854 65.739 287.854 67.242 306.804 67.242 306.804 69.072 310.422 69.072 310.422 74.597 315.149 74.597 315.149 78.041 319.995 78.041 319.995 83.108 323.801 83.108 323.801 86.667 351.873 86.667 351.873 94.938 368.833 94.938 368.833 105.672 413.758 105.672 413.758 147.448 419.007 147.448 419.007 189.5 442.545 189.5"/>
                  <path stroke="#D8137D" stroke-width="2" d="M68 58.771L355.878 58.771 355.878 63.611 384.258 63.611 384.258 70.023 389.927 70.023 389.927 77.39 392.216 77.39 392.216 85.181 396.655 85.181 396.655 94.745 411.394 94.745 411.394 118.038 417.128 118.038 417.128 144.645 426 144.645 426 189.771"/>
              </g>
          </svg> -->

          <!-- <img src="/assets/img/template/group-15.png" > -->

          <!--<svg xmlns="http://www.w3.org/2000/svg" width="448" height="244" viewBox="0 0 448 244">
              <g fill="none" fill-rule="evenodd">
                  <g>
                      <g>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="185">40</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="164">50</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="143">50</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="121">70</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="100">80</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="38.99" y="78">90</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="30.985" y="55">100</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="63.498" y="204">0</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="149.995" y="204">20</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="240.495" y="204">40</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="331.495" y="204">60</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="14" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="422.495" y="205">80</tspan>
                          </text>
                          <path stroke="#929897" stroke-linecap="square" stroke-width="2" d="M69 49.771V183.5M65 115h4m-4-23h4m-4 45h4m-4 22h4m-4-87h4m-4-22h4M446.75 180.5L64.5 180.5M158 180.5L158 184.5M250 180.5L250 184.5M339 180.5L339 184.5M430 180.5L430 184.5" transform="translate(-776 -9905) translate(776 9905)"/>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="16" transform="translate(-776 -9905) translate(776 9905) rotate(-90 11 122)">
                              <tspan x="-88.762" y="128">Geschätztes Überleben (%)</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="12" font-weight="500" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="130" y="165">Männer </tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans-Semibold, Open Sans" font-size="12" font-weight="500" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="130" y="141">Frauen </tspan>
                          </text>
                          <path stroke="#007BB6" stroke-width="2" d="M93 160.5L120 160.5" transform="translate(-776 -9905) translate(776 9905)"/>
                          <path stroke="#D8137D" stroke-width="2" d="M93 136.5L120 136.5" transform="translate(-776 -9905) translate(776 9905)"/>
                          <text fill="#000" font-family="OpenSans, Open Sans" font-size="16" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="198.012" y="239">Alter (in Jahren)</tspan>
                          </text>
                          <text fill="#000" font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" transform="translate(-776 -9905) translate(776 9905)">
                              <tspan x="135.289" y="17">(Männer n = 360; Frauen n = 317)</tspan>
                          </text>
                          <path stroke="#007BB6" stroke-width="2" d="M69.5 50L186.53 50 186.53 51.947 253.632 51.947 253.632 53.853 282.403 53.853 282.403 55.205 284.407 55.205 284.407 56.739 288.854 56.739 288.854 58.242 307.804 58.242 307.804 60.072 311.422 60.072 311.422 65.597 316.149 65.597 316.149 69.041 320.995 69.041 320.995 74.108 324.801 74.108 324.801 77.667 352.873 77.667 352.873 85.938 369.833 85.938 369.833 96.672 414.758 96.672 414.758 138.448 420.007 138.448 420.007 180.5 443.545 180.5" transform="translate(-776 -9905) translate(776 9905)"/>
                          <path stroke="#D8137D" stroke-width="2" d="M69 49.771L356.878 49.771 356.878 54.611 385.258 54.611 385.258 61.023 390.927 61.023 390.927 68.39 393.216 68.39 393.216 76.181 397.655 76.181 397.655 85.745 412.394 85.745 412.394 109.038 418.128 109.038 418.128 135.645 427 135.645 427 180.771" transform="translate(-776 -9905) translate(776 9905)"/>
                      </g>
                  </g>
              </g>
          </svg>


        </div>
        <div class="info-section-legend-bold">
          Behandelt mit Agalsidase alfa<sup class="info-section-text-ref">18</sup>
        </div>
        <div class="info-section-legend">
          Abb. Modifiziert nach SCHIFFMANN, R. et al. 2019<sup class="info-section-text-ref">18</sup>
        </div>
        <div class="info-section-legend-sm">
          FOS-Kohorte*; n = 677
        </div>

      </div>

    </div>

    <div class="info-section-text info-section-text-3">
      * Die Daten stammen aus retrospektiven Analysen von Krankenakten im Rahmen der Beobachtungsstudie FOS, bei denen Verzerrungen und
      Störgrößen schwer zu kontrollieren sind und die von der Richtigkeit der schriftlichen Aufzeichnungen abhängen.
    </div>-->



  </div>

  <div class="info-section-ribbon info-section-8" style="margin-bottom: 100px;">

    <div class="info-section-ribbon-left">
    </div>

    <div class="info-section-ribbon-right">
    </div>

    <div class="info-section-title">
      <h2>
        Eine frühe Diagnose kann<br>
        Lebensqualität bewahren
      </h2>
    </div>

    <div class="info-section-text">
      Morbus Fabry geht unbehandelt mit einer deutlich reduzierten Lebenserwartung und
      <a routerLink="/diagnose">verminderten Lebensqualität</a> einher. Daher sind eine frühe Diagnose und damit verbunden angemessene und rechtzeitige Therapiemaßnahmen zum Schutz der Organe wichtig.
    </div>

  </div>


  <app-footer>
  </app-footer>

</div>
